var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.782,
    height: 14.782,
    viewBox: "0 0 14.782 14.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fax") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.848,3.7H.924A.924.924,0,0,0,0,4.619v9.239a.924.924,0,0,0,.924.924h.924a.924.924,0,0,0,.924-.924V4.619A.924.924,0,0,0,1.848,3.7Zm12.011.924V2.23a.924.924,0,0,0-.271-.653L12.281.271A.924.924,0,0,0,11.628,0H4.619A.924.924,0,0,0,3.7.924V13.858a.924.924,0,0,0,.924.924h9.239a.924.924,0,0,0,.924-.924V5.543A.924.924,0,0,0,13.858,4.619ZM8.315,12.473a.462.462,0,0,1-.462.462H6.929a.462.462,0,0,1-.462-.462v-.924a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462Zm0-3.7a.462.462,0,0,1-.462.462H6.929a.462.462,0,0,1-.462-.462V7.853a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462Zm3.7,3.7a.462.462,0,0,1-.462.462h-.924a.462.462,0,0,1-.462-.462v-.924a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462Zm0-3.7a.462.462,0,0,1-.462.462h-.924a.462.462,0,0,1-.462-.462V7.853a.462.462,0,0,1,.462-.462h.924a.462.462,0,0,1,.462.462Zm.462-3.234H5.081V1.386h6.005V2.31a.462.462,0,0,0,.462.462h.924Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.ba7bee29362cc084d1d0f393f0ea34ab.svg";
export { ForwardRef as ReactComponent };